import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  AsyncValidatorFn,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { changePassObj } from "src/app/models/login";
import Swal from "sweetalert2";
import { CustomValidators } from "../forget-password/custom-validators";
import { AccountService } from "src/app/services/account.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  changePassObj: changePassObj = {} as changePassObj;
  resetPassWordForm: FormGroup;
  passwordStepper: any;
   showPassword1: boolean = false;
   showPassword2: boolean = false;
  lang: string;
  constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private translate: TranslateService,
    private accService: AccountService,
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.lang = this.translate.currentLang
    this.passwordStepper = 1;
    this.resetPassWordForm = new FormGroup(
      {
        currentPassword: new FormControl(
          null,
          Validators.compose([
            // check whether the entered password numbers Only
            Validators.required,
          ])
        ),
        firstNewPassword: new FormControl(
          null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true,
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true,
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true,
            }),
            // check whether the entered password has a special character
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true,
              }
            ),
            Validators.minLength(8),
          ])
        ),
        reFirstNewPassword: new FormControl(
          null,
          Validators.compose([Validators.required])
        ),
        secondNewPassword: new FormControl(
          null,
          Validators.compose([
            // check whether the entered password numbers Only

            Validators.required,
            Validators.pattern("[-_a-zA-Z0-9]*"),
            Validators.minLength(4),
            Validators.maxLength(6)
          ])
        ),
        reSecondNewPassword: new FormControl(
          null,
          Validators.compose([Validators.required])
        ),
      },
      [
        CustomValidators.firstPasswordMatchValidator as AsyncValidatorFn,
        CustomValidators.secondPasswordMatchValidator as AsyncValidatorFn,
      ]
    );

  }

  onSubmit() {
    this.changePassObj.relationCode = JSON.parse(localStorage.getItem('userProfile')).RelationCode;
    this.changePassObj.currentPassword = this.resetPassWordForm.value.currentPassword;
    this.changePassObj.password = this.resetPassWordForm.value.firstNewPassword;
    this.changePassObj.secondPassword =
      this.resetPassWordForm.value.secondNewPassword;
    this.recaptchaV3Service
      .execute("importantAction")
      .subscribe((token: string) => {
        this.apiService.changePassword(this.changePassObj).subscribe(
          (arg) =>  {
            let resMsg :any;
            resMsg = arg
             if(resMsg.IsSuccess == true){

             Swal.fire({
               position: "center",
               icon: "success",
               title: this.translate.instant("pass-success-msg"),
               showConfirmButton: false,
               timer: 4500,
             });
             let username = sessionStorage.getItem("userName");
             this.apiService.logOut(username).subscribe(res =>{
               this.accService.logout();
               this.router.navigate(["/login"]);
             })
             }else{
               Swal.fire({
                 position: "center",
                 icon: "error",
                 title: this.translate.instant("curr-pass-error-msg"),
                 showConfirmButton: false,
                 timer: 4500,
               });
             }
           },
          (err) => {
            this.resetPassWordForm.reset()
            this.passwordStepper = 1;
            Swal.fire({
              position: "center",
              icon: "error",
              title: this.translate.instant("pass-error-msg"),
              showConfirmButton: false,
              timer: 4500,
            });
          }
        );
      });
  }
  next() {
    this.showPassword1 = false;
    this.showPassword2 = false;
    this.passwordStepper = this.passwordStepper + 1;
  }
  back() {
    this.showPassword1 = false;
    this.showPassword2 = false;
    this.passwordStepper -= 1;
  }
}
